
<template>
      <div
      id="app"
      @click="mainBack"
      :style="{opacity: showMain ? '1 !important' : '0'}"
    >
      <div class="nav">
        <a
          v-if="platform !== 'pc'"
          class="logo"
          href="javascript:void(0)"
        >
          <img   :src="require('./images/logo.png')" alt="" />
        </a>
        <a
          v-if="platform === 'pc'"
          class="logo"
          href="javascript:void(0)"
        >
          <img  :src="require('./images/logo.png')" alt="" />
        </a>
        <div class="right">
          <a
            v-if="platform !== 'pc'"
            class="to"
            href="https://www.sugon.com/quality/control"
          >
            了解曙光智能制造
          </a>
          <a
            v-if="platform === 'pc'"
            target="_blank"
            class="to"
            href="https://www.sugon.com/quality/control"
          >
            了解曙光智能制造
          </a>
          <div
            v-if="isSignedNingchang"
            @click.stop="showSubList"
            class="avatar"
            :style="{backgroundImage: `url(${require('./img/avatar.svg')})`}"
          >
            <div
              v-if="platform === 'pc' ? true : ifSubList"
              :style="{display: ifSubList ? 'block' : ''}"
            >
              <div v-if="!isInWechatWeb" class="wrap">
                <a :href="logout_url">
                  退出登录
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="banner">
        <!-- 报名 -->
        <a href="https://www.sugon.com/forms/signup/6"><img :src="banner" alt="" /></a>
      </div>
      <div v-show="countTime" class="cutDown">
        <div class="w">
          发布会倒计时
        </div>
        <div class="line"></div>
        <div class="time" v-html="countTime"></div>
      </div>
    <!--  <div class="liveVideo">
       pc
        <iframe
          v-if="platform === 'pc' && showIframe"
          allow="camera *;microphone *;"
          allowfullscreen="true"
          border="0"
          src="https://live.vhall.com/webinar/inituser/481657414"
          width="1200"
          height="600"
        >
        </iframe>
         手机 会时和会后 
        <iframe
          v-if="platform === 'phone' && showIframe"
          allow="camera *;microphone *;"
          allowfullscreen="true"
          :width="iframeWidth"
          :height="iframeHeight"
          border="0"
          src="https://live.vhall.com/webinar/inituser/481657414"
        >
        </iframe>
      </div> 
    -->
    <div class="ningchangLongFloor">
        <img class="bg" :src="require('./img/lines.png')" alt="" />
        <div class="item">
          <div class="title">
            汇聚权威
          </div>
          <div class="subtitle">
            <div>汇聚业内专家、技术大咖，深入分析当下和未来智能</div>
            <div>制造趋势与机遇，助力中国科技业、制造业高质量发展 。</div>
          </div>
        </div>
        <div class="item bd">
          <div class="title">
            聚焦前沿
          </div>
          <div class="subtitle">
            <div>围绕“先进制造”如何促进工业转型升级、满足各地</div>
            <div>信息技术应用创新发展需求等前沿话题展开探讨。</div>
          </div>
        </div>
        <div class="item">
          <div class="title">
            融合实践
          </div>
          <div class="subtitle">
            <div>通过分析曙光先进计算与智能制造融合实践案例，探讨如何抓住</div>
            <div>“新基建”历史机遇，提质增效、节本降耗 ，打造科技品牌名片。</div>
          </div>
        </div>
      </div>
      <div class="invite invite2">
        <div class="mainTitle">
          <img :src="require('./img/title-1.png')" alt="" />
        </div>
        <div class="content">
          <div>
            <div class="peo">
              <img :src="require('./images/libohu.png')" alt="" />
              <div class="info">
                <div class="top">
                  <div class="name">
                    李伯虎
                  </div>
                </div>
                <div class="subInfo">
                  <div>中国工程院院士</div>
                </div>
              </div>
            </div>
            <div class="peo">
              <img :src="require('./images/zhangli.png')" alt="" />
              <div class="info">
                <div class="top">
                  <div class="name">
                    张立
                  </div>
                </div>
                <div class="subInfo">
                  <div>中国电子信息产业</div>
                  <div>发展研究院院长</div>
                </div>
              </div>
            </div>
            <div class="peo">
              <img :src="require('./images/qudk.png')" alt="" />
              <div class="info">
                <div class="top">
                  <div class="name">
                    曲道奎
                  </div>
                </div>
                <div class="subInfo">
                  <div>沈阳新松机器人总裁</div>
                </div>
              </div>
            </div>

          </div>
          <div>
            <div class="peo">
              <img :src="require('./images/zhuym.png')" alt="" />
              <div class="info">
                <div class="top">
                  <div class="name">
                    朱毅明
                  </div>
                </div>
                <div class="subInfo">
                  <div>和利时集团技术总监</div>
                </div>
              </div>
            </div>
            <div class="peo">
              <img :src="require('./images/renjy.png')" alt="" />
              <div class="info">
                <div class="top">
                  <div class="name">
                    任京暘
                  </div>
                </div>
                <div class="subInfo">
                  <div>中科曙光高级副总裁</div>
                </div>
              </div>
            </div>
            <div class="peo">
              <img :src="require('./images/zhangyh.png')" alt="" />
              <div class="info">
                <div class="top">
                  <div class="name">
                    张迎华
                  </div>
                </div>
                <div class="subInfo">
                  <div>中科曙光副总裁</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="reLook" v-show="reLookTabs.show">
        <div class="mainTitle">
          <img :src="require('./img/title-2.png')" alt="" />
        </div>
        <div v-if="platform === 'pc'" class="tabs">
          <div
            class="tab"
            v-for="(tab, i) in reLookTabs.titles"
            :class="[reLookTabs.currentIndex === i + 2 && i > 0 || reLookTabs.currentIndex < 3 && i === 0 ? 'current' : '']"
            :key="tab.title"
            @click.stop="reLookTabSwitch(i)"
          >
            {{ tab.title }}
          </div>
        </div>
        <div v-if="platform !== 'pc'" class="tabs">
          <div
            class="tab"
            v-for="(tab, i) in reLookTabs.titles"
            :class="[reLookTabs.currentIndex >= reLookTabs.list.jiabinjiyuIndex && i > 0 || reLookTabs.currentIndex < reLookTabs.list.jiabinjiyuIndex && i < 1 ? 'current' : '']"
            :key="tab.title"
            @click.stop="reLookTabSwitch(i)"
          >
            {{ tab.title }}
          </div>
        </div>
        <div class="videos">
          <swiper ref="mySwiper" :options="swiperOptions" :auto-update="true">
            <swiper-slide
              v-for="(video, i) in reLookTabs.list.list"
              :key="i"
            >
              <div
                class="video"
                :style="{background: video.playing ? 'black' : ''}"
                @click.stop="playVideo(i)"
              >
                <img v-if="!video.playing" :src="video.poster" class="poster" alt="" />
                <div v-if="!video.playing" class="info">
                  <img class="play" :src="require('./img/play.png')" alt="" />
                  <div class="title">
                    {{ video.title }}
                  </div>
                </div>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
          <video @click.stop="empty()" v-if='reLookTabs.videoUrl' controls="controls" autoplay="autoplay" :src="reLookTabs.videoUrl"></video>
        </div>
      </div>

      <div class="schedule">
        <div class="mainTitle">
          <img :src="require('./img/title-4.png')" alt="" />
        </div>
        <div class="table">
          <img :src="require('./images/richeng.png')" alt="" />
        </div>
      </div>

      <div v-show="xuanchuanpian" class="brandVideos">
        <div class="mainTitle">
          <img :src="require('./images/title-5.png')" alt="" />
        </div>
        <div v-if="platform === 'pc'" class="videos">
          <div class="list">
            <div class="videoItem" v-for="(video, i) in brandVideos.list" :key="i">
              <img :src="video.poster" alt="" />
              <div class="info" @click.stop="playBrandVideo(video.url)">
                <img :src="require('./img/play.png')" alt="">
                <div class="title">
                  {{video.title}}
                </div>
              </div>
            </div>
          </div>
          <div v-if="currentVideo" class="currentVideo">
            <video @click.stop="empty()" :src="currentVideo" controls="controls" autoplay="autoplay"></video>
          </div>
        </div>
        <div v-if="platform !== 'pc'" class="videos">
          <div class="list">
            <div class="videoItem" v-for="(video, i) in brandVideos.list" :key="i" :style="{background: video.playing ? 'black' : ''}">
              <img v-if="!video.playing" :src="video.poster" alt="" />
              <div v-if="!video.playing" class="info" @click.stop="playBrandVideoMobile(i)">
                <img :src="require('./img/play.png')" alt="">
                <div class="title">
                  {{video.title}}
                </div>
              </div>
              <video @click.stop="empty()" v-if="video.playing" :src="video.url" autoplay="autoplay" controls="controls"></video>
            </div>
          </div>
        </div>
      </div>

      <div
        class="ningchangBrandIntro"
        :style="{backgroundImage: `url(${require('./img/companyBg2.jpg')})`}"
      >
        <div class="brandWrap">
          <div class="left">
            <img :src="require('./images/sugonlogo.png')" alt="" />
          </div>
          <div class="right">
            <div class="s1">
              中科曙光秉承“智能绿色、精益融合”的理念，不断提升质量管理能力和智能制造解决方案能力，为信息产业打造领先的智能工厂，并为市场提供安全可靠、品质一流的高端整机产品和服务。中科曙光愿联合业内最优秀合作伙伴，一起致力于先进制造技术的研究和进步，助力信息产业迈向高质量发展新阶段。
            </div>
          </div>
        </div>
      </div>

      <div v-show="xuanchuanpian" class="products">
        <div class="mainTitle">
          <img class="corner" :src="require('./img/title-6.png')" alt="" />
        </div>
        <div class="content">
          <div class="product" @click.stop="toProduct(165)">
            <div class="left">
              <div class="top">
                <div class="line"></div>
                <div class="title">
                  <div class="bigTitle">
                    通用机架服务器
                  </div>
                  <div class="subTitle">
                    弹性扩展 稳定高效
                  </div>
                </div>
              </div>
              <a class="bottom">
                +了解详情
              </a>
            </div>
            <div class="right">
              <img :src="require('./img/product1.png')" alt="" />
            </div>
            <img class="corner" :src="require('./img/corner.png')" alt="" />
          </div>
          <div class="product" @click.stop="toProduct(166)">
            <div class="left">
              <div class="top">
                <div class="line"></div>
                <div class="title">
                  <div class="bigTitle">
                    人工智能服务器
                  </div>
                  <div class="subTitle">
                    智能加速 多元场景
                  </div>
                </div>
              </div>
              <a class="bottom">
                +了解详情
              </a>
            </div>
            <div class="right">
              <img :src="require('./img/product4.png')" alt="" />
            </div>
            <img class="corner" :src="require('./img/corner.png')" alt="" />
          </div>
          <div class="product" @click.stop="toProduct(168)">
            <div class="left">
              <div class="top">
                <div class="line"></div>
                <div class="title">
                  <div class="bigTitle">
                    多节点服务器
                  </div>
                  <div class="subTitle">
                    性能强劲 融合均衡
                  </div>
                </div>
              </div>
              <a class="bottom">
                +了解详情
              </a>
            </div>
            <div class="right">
              <img :src="require('./img/product3.png')" alt="" />
            </div>
            <img class="corner" :src="require('./img/corner.png')" alt="" />
          </div>
          <div class="product" @click.stop="toProduct(167)">
            <div class="left">
              <div class="top">
                <div class="line"></div>
                <div class="title">
                  <div class="bigTitle">
                    边缘计算服务器
                  </div>
                  <div class="subTitle">
                    开放易用 耐热抗震
                  </div>
                </div>
              </div>
              <a class="bottom">
                +了解详情
              </a>
            </div>
            <div class="right">
              <img :src="require('./img/product2.png')" alt="" />
            </div>
            <img class="corner" :src="require('./img/corner.png')" alt="" />
          </div>
        </div>
      </div>

      <!-- <div class="news">
        <img class="bg" src="require('./img/earth.png" alt="" />
        <div class="mainTitle">
          <img src="require('./img/title-7.png" alt="" />
        </div>
        <div class="list">
          <div class="item">
            <div class="thumb">
              <img src="" alt="" />
            </div>
            <div class="title">
              <div class="line"></div>
              <div class="title">
                领先的Intel&Nvidia技术架构广泛而开放的商业合作模式
              </div>
            </div>
          </div>
          <div class="item">
            <div class="thumb">
              <img src="" alt="" />
            </div>
            <div class="title">
              <div class="line"></div>
              <div class="title">
                领先的Intel&Nvidia技术架构广泛而开放的商业合作模式
              </div>
            </div>
          </div>
          <div class="item">
            <div class="thumb">
              <img src="" alt="" />
            </div>
            <div class="title">
              <div class="line"></div>
              <div class="title">
                领先的Intel&Nvidia技术架构广泛而开放的商业合作模式
              </div>
            </div>
          </div>
        </div>
        <div class="checkMoreButton">查看更多</div>
      </div> -->

      <!-- <div class="partner">
        <div class="mainTitle">
          <img src="require('./img/title-8.png" alt="" />
        </div>
        <div class="list"></div>
      </div> -->

      <!-- <div class="partner2">
        <img class="bg" src="require('./img/earth.png" alt="" />
        <div class="mainTitle">
          <img src="require('./img/title-9.png" alt="" />
        </div>
        <div class="list">
          <img
            :src="`require('./img/logos${platform === 'phone' ? '-sm' : ''}.png`"
            alt=""
          />
        </div>
      </div> -->
      <div class="zhichiidanwei">
        <div class="mainTitle">
        </div>
        <div class="zcdw">
          主办单位：中国电子信息产业发展研究院<br >
          承办单位：中科曙光&nbsp;英特尔
        </div>
      </div>
      <img
        class="backToTop"
        @click.stop="backToTop"
        :src="require('./img/backToTop.png')"
        alt=""
      />
      <div class="footer">
        版权所有 © 曙光信息产业股份有限公司
        <a href="http://www.beian.miit.gov.cn/" target="_blank"
          >&nbsp;&nbsp;京ICP备20011261号</a
        >
      </div>
    </div>
</template>

<script>

import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import axios from "axios";


const platforms = {
  pc: "pc",
  phone: "phone",
};

const width =
  window.innerWidth ||
  document.documentElement.clientWidth ||
  document.body.clientWidth ||
  window.screen.width ||
  400;
const height =
  window.innerHeight ||
  document.documentElement.clientHeight ||
  document.body.clientHeight ||
  window.screen.height ||
  400;
const platform = width >= 1200 ? platforms.pc : platforms.phone;

const isInWechatWeb = () => {
  const ua = navigator.userAgent.toLowerCase()
  return (
    (ua.match(/micromessenger/i) &&
      !ua.match(/miniprogram/i)) &&
    (window.__wxjs_environment !== 'miniprogram')
  )
}

export default {
  name: 'app',
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
        xuanchuanpian:false,
    isInWechatWeb: isInWechatWeb(),
    logout_url: window.logout_url || "/activity/user/logout",
    swiperOptions: {
      centeredSlides: true,
      spaceBetween: 10,
      slidesPerView: "auto",
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      onTransitionStart: function () {
        if (!window.app || !window.app.$children[0] || !window.app.$children[0].reLookTabs) {
          return
        }
        window.app.$children[0].reLookTabs.list.list.forEach((ele) => {
          ele.playing = false;
        });
        window.app.$children[0].reLookTabs.videoUrl = "";
      },
      onTransitionEnd: function (swiper) {
        if (!window.app || !window.app.$children[0] || !window.app.$children[0].reLookTabs) {
          return
        }
        window.app.$children[0].reLookTabs.currentIndex = swiper.activeIndex
      }
    },
    width,
    showMain: false,
    isSignedNingchang: window.isSignedNingchang || false,
    currentVideo: "",
    platform,
    go_time: new Date("2020/4/21 10:00:00"),
    video_time: new Date("2020/4/21 9:45:00"),
    countTime: false,
    showIframe: false,
    ifSubList: false,
    banner:
      platform === platforms.pc
        ? require('./images/banner-pc.jpg')
        : require('./images/banner-mobile.jpg'),
    poster:
      platform === platforms.pc
        ? require('./img/poster-1.png')
        : require('./img/poster-1-sm.png'),
    poster2:
      platform === platforms.pc
        ? require('./img/poster-2.png')
        : require('./img/poster-2-sm.png'),
    reLookTabs: {
      currentIndex: 0,
      show: false,
      videoUrl: "",
      titles: [
        {
          title: "发布",
          show: true,
        },
        {
          title: "嘉宾寄语",
          show: true,
        },
      ],
      list: {
        current: 0,
        jiabinjiyuIndex: -1,
        list: [],
      },
    },
    brandVideos: {
      currentIndex: 0,
      list: [
        {
          poster: require('./img/brandv-1.jpg'),
          title: '曙光智造品牌视频',
          url: "https://www.sugon.com",
          playing: false
        },
        {
          poster: require('./img/brandv-2.jpg'),
          title: '合作伙伴祝福短视频',
          url: "https://www.sugon.com",
          playing: false
        },
      ],
    }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    iframeWidth() {
      return this.width > 600 ? 600 : this.width;
    },
    iframeHeight() {
      let h = (this.width > 600 ? 600 : this.width) * 1.5;
      if (h > height - 120) {
        h = height - 120;
      }
      return h;
    },
  },
  created() {
    if (this.platform === platforms.pc) {
      this.reLookTabs.titles = [
        {
          title: "张立",
          show: true,
        },
        {
          title: "李伯虎",
          show: true,
        },
        {
          title: "任京暘",
          show: true,
        },
        {
          title: "曲道奎",
          show: true,
        },
        {
          title: "张迎华",
          show: true,
        },
        {
          title: "揭牌仪式",
          show: true,
        },
        {
          title: "马少杰",
          show: true,
        },
        {
          title: "张永",
          show: true,
        },
      ]
    }
    this.countDown();
    setInterval(() => {
      this.countDown();
    }, 1000);

    // axios
      // .get("https://nc.qwebgo.com/api/show_info")
      // .then((res) => {
        // const ningchangfabu = res.data.ningchangfabu;
        // const jiabinjiyu = res.data.jiabinjiyu;
        // for (var item in ningchangfabu) {
          // if (ningchangfabu[item].show) {
            this.reLookTabs.titles[0].show = true;
          // } else {
            // this.reLookTabs.titles[0].show = true;
            // continue;
          // }
          // if (item === "zongcai") {
            this.reLookTabs.list.list.push({
              type: "ningchangfabu",
              poster: require('./img/brand-1.jpg'),
              url: "https://mp4",
              title: "title",
            });
          // } else if (item === "zhexue") {
            this.reLookTabs.list.list.push({
              type: "ningchangfabu",
              poster: require('./img/brand-2.jpg'),
              url: "https://.mp4",
              title: "title",
            });
          // } else if (item === "fabu") {
            this.reLookTabs.list.list.push({
              type: "ningchangfabu",
              poster: require('./img/brand-3.jpg'),
              url: "https://.mp4",
              title: "title",
            });
          // }
        // }

        // for (var item in jiabinjiyu) {
          // if (jiabinjiyu[item].show) {
            this.reLookTabs.titles[1].show = true;
            if (this.reLookTabs.list.jiabinjiyuIndex < 0) {
              this.reLookTabs.list.jiabinjiyuIndex = this.reLookTabs.list.list.length;
            }
          // } else {
            // this.reLookTabs.titles[1].show = true;
            // if (this.reLookTabs.list.jiabinjiyuIndex < 0) {
            //   this.reLookTabs.list.jiabinjiyuIndex = this.reLookTabs.list.list.length;
            // }
            // continue;
          // }
          // if (item === "intel") {
            this.reLookTabs.list.list.push({
              type: "jiabinjiyu",
              poster: require('./img/video1.jpg'),
              url: "https://mp4",
              title: "title",
            });
          // } else if (item === "nvidia") {
            this.reLookTabs.list.list.push({
              type: "jiabinjiyu",
              poster: require('./img/video2.jpg'),
              url: "https://www.sugon.com",
              title: "title",
            });
          // } else if (item === "microsoft") {
            this.reLookTabs.list.list.push({
              type: "jiabinjiyu",
              poster: require('./img/video3.jpg'),
              url: "https://www.sugon.com",
              title: "title",
            });
          // } else if (item === "vmware") {
            this.reLookTabs.list.list.push({
              type: "jiabinjiyu",
              poster: require('./img/video4.jpg'),
              url: "https://www.sugon.com",
              title: "title",
            });
          // } else if (item === "ucloud") {
            this.reLookTabs.list.list.push({
              type: "jiabinjiyu",
              poster: require('./img/video5.jpg'),
              url: "https://www.sugon.com",
              title: "title",
            });
          // } else if (item === "jd") {
            this.reLookTabs.list.list.push({
              type: "jiabinjiyu",
              poster: require('./img/video6.jpg'),
              url: "https://www.sugon.com",
              title: "title",
            });
          // } else if (item === "pingan") {
            this.reLookTabs.list.list.push({
              type: "jiabinjiyu",
              poster: require('./img/video7.jpg'),
              url: "https://www.sugon.com",
              title: "title",
            });
          // }
        // }
        // if (
        //   this.reLookTabs.list.list[0] &&
        //   this.reLookTabs.list.list[0].type === "jiabinjiyu"
        // ) {
        //   this.reLookTabs.currentIndex = 1;
        // }
        // if (this.reLookTabs.list.list.length > 2) {
          // console.log('length', 2)
          setTimeout(() => {
            this.swiper.slideTo(0, 0, true);
            this.reLookTabs.currentIndex = 0;
          }, 200);
        // }
        // if (this.reLookTabs.list.list.length) {
          // this.reLookTabs.show = true;
        // }
        console.log(this.reLookTabs);
      // })
      // .catch((err) => { });
  },
  mounted() {
    this.showMain = true;
    try {
      if (this.isSignedNingchang) {

        const tiped = window.localStorage.getItem('tiped');
        if (!tiped) {
          var tip = document.getElementById("tip");
          tip.style.display = "block";
          setTimeout(() => {
            tip.style.opacity = 1;
            tip.style.transform = "translateX(0)";
          }, 100);
          window.localStorage.setItem('tiped', '1');
          setTimeout(() => {
            tip.style.opacity = 0;
            tip.style.transform = "translateX(100px)";
            setTimeout(() => {
              tip.style.display = "none";
            }, 500);
          }, 3000);
        }
      } else {
        window.localStorage.setItem('tiped', '');
      }
    } catch (error) {
      console.log(error);
    }

    axios.get("https://www.sugon.com/forms/time")
    setInterval(() => {
      axios.get("https://www.sugon.com/forms/time")
    }, 10000)

  },
  methods: {
    empty() {

    },
    mainBack() {
      this.ifSubList = false
      this.brandVideos.list.forEach(ele => {
        ele.playing = false
      })
      this.reLookTabs.list.list.forEach((ele) => {
        ele.playing = false;
      });
      this.currentVideo = ''
      this.reLookTabs.videoUrl = "";
    },
    playBrandVideoMobile(i) {
      this.brandVideos.list.forEach(ele => {
        ele.playing = false
      })
      this.brandVideos.list[i].playing = true
    },
    playBrandVideo(url) {
      this.currentVideo = url
    },
    showSubList() {
      if (this.platform === "pc") {
        return;
      }
      this.ifSubList = !this.ifSubList;
    },
    reLookTabSwitch(i) {
      this.reLookTabs.list.list.forEach((ele) => {
        ele.playing = false;
      });
      this.reLookTabs.videoUrl = "";
      if (this.platform === platforms.pc) {
        if (i === 0 ) {
          this.reLookTabs.currentIndex = 0
          this.swiper.slideTo(this.reLookTabs.currentIndex, 500, true);
        }
        else {
          this.reLookTabs.currentIndex = i + 2
          this.swiper.slideTo(this.reLookTabs.currentIndex, 500, true);
        }
      }
      else {
        this.reLookTabs.currentIndex = i === 0 ? 0 : this.reLookTabs.list.jiabinjiyuIndex;
        this.swiper.slideTo(this.reLookTabs.currentIndex, 500, true);
      }
    },
    stopPlaying() {
      this.reLookTabs.list.list.forEach((ele) => {
        ele.playing = false;
      });
      this.reLookTabs.videoUrl = "";
    },
    backToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    toSignUp() {
      if (this.isSignedNingchang) {
        var tip = document.getElementById("tip");
        tip.style.display = "block";
        setTimeout(() => {
          tip.style.opacity = 1;
          tip.style.transform = "translateX(0)";
        }, 100);
        setTimeout(() => {
          tip.style.opacity = 0;
          tip.style.transform = "translateX(100px)";
          setTimeout(() => {
            tip.style.display = "none";
          }, 500);
        }, 3000);
        return;
      }
      var signup_url = window.signup_url || "/activity/signup?pid=1";
      window.location.href = signup_url
    },
    toProduct(id) {
      window.location.href =
        "https://www.sugon.com/product/overview?category_id=" + id;
    },
    playVideo(index) {
      console.log(this.reLookTabs.list.list[index]);
      this.reLookTabs.list.list.forEach((ele) => {
        ele.playing = false;
      });
      this.reLookTabs.videoUrl = "";
      if (index !== this.reLookTabs.currentIndex) {
        this.swiper.slideTo(index, 500, true);
        this.reLookTabs.currentIndex = index;
      } else {
        this.reLookTabs.list.list[index].playing = true;
        this.reLookTabs.videoUrl = this.reLookTabs.list.list[index].url;
      }
    },
    countDown() {
      var now_time = new Date();
      this.showIframe = this.video_time - now_time < 0 ? true : false;
      var alltime = this.go_time.getTime() - now_time.getTime(); //总的时间（毫秒）
      if (alltime <= 0) {
        this.countTime = false
        return false;
      }
      //console.log(haosecond);
      var second = parseInt((alltime / 1000) % 60); //秒
      //console.log(second);
      var minute = parseInt((alltime / 1000 / 60) % 60); //  分钟
      // console.log(minute);
      var hour = parseInt((alltime / 1000 / 60 / 60) % 24); //小时
      // console.log(hour);
      var day = parseInt((alltime / 1000 / 60 / 60 / 24) % 30); //天数
      if (second.toString().length < 2) {
        second = `0${second}`;
      }
      if (minute.toString().length < 2) {
        minute = `0${minute}`;
      }
      if (hour.toString().length < 2) {
        hour = `0${hour}`;
      }
      if (day.toString().length < 2) {
        day = `0${day}`;
      }
      var time1 = day + "<span>天</span>" + hour + ":" + minute + ":" + second;
      this.countTime = time1;
    },
  }
}
</script>

